module.exports = __webpack_public_path__ + "static/media/vail-16.5d6ba717.jpg";